import { SIDEMENU_OPEN } from '../action-types/sidemenu.action-types';

export type SideMenuReducer = {
  sidemenuOpen: boolean;
};

const initialState: SideMenuReducer = {
  sidemenuOpen: false,
};

const sideMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIDEMENU_OPEN: {
      return {
        ...state,
        sidemenuOpen: action.isOpen,
      };
    }
    default: {
      return state;
    }
  }
};

export default sideMenuReducer;
